import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'
import EditPlayerSquadForm from './EditPlayerSquadForm'
import EditPlayerSquadListTemplate from './templates/EditPlayerSquadListTemplate'

function EditPlayerSquad({ teamId }) {
    const [players, setPlayers] = useState([])
    const [showEdit, setShowEdit] = useState(false)
    const [playerId, setPlayerId] = useState()

    useEffect(() => {
        try {
            const playersTeamRef = firestore
                .collection('teams')
                .doc(teamId)
                .collection('players')
            playersTeamRef.onSnapshot(({ docs }) => {
                const players = docs.map((doc) => {
                    return { id: doc.id, ...doc.data() }
                })
                setPlayers(players)
            })
        } catch (error) {}
    }, [teamId])

    function toggleEdit(playerId) {
        if (showEdit) {
            setShowEdit(false)
        } else {
            setPlayerId(playerId)
            setShowEdit(true)
        }
    }

    return (
        <div>
            {!showEdit && (
                <>
                    {players?.map((player, index) => {
                        return (
                            <EditPlayerSquadListTemplate
                                key={index}
                                player={player}
                                teamId={teamId}
                            />
                        )
                    })}
                </>
            )}
            {showEdit && (
                <EditPlayerSquadForm
                    playerId={playerId}
                    teamId={teamId}
                    setShowEdit={setShowEdit}
                />
            )}
        </div>
    )
}
export default EditPlayerSquad
